{
  "general": {
    "title": "Comparer les options",
    "intro": "Un aperçu rapide de la différence entre Communauté, Abonnement et Achat Unique.",
    "tableheader": "Abonnement",
    "note1": "* Options d'achat de groupe et remises sur volume disponibles.",
    "note2": "** Langues prises en charge danois, allemand, anglais, espagnol, suédois, français, italien, norvégien, polonais, portugais (Brésil), russe, suédois",
    "note3": "*** Nécessite un compte myboardmaker.com  Community. Destiné au stockage d'activités uniquement."
  },
  "columnHeadings": {
    "community": "COMMUNITY",
    "onetime": "ACHAT UNIQUE*",
    "personal": "PERSONNEL",
    "professional": "PROFESSIONNEL",
    "organization": "ORGANISATION*"
  },
  "mobileHeadings": {
    "community": "Community",
    "onetime": "Achat unique*",
    "personal": "Personnel",
    "professional": "Professionnel",
    "organization": "Organisation*"
  },
  "rowHeadings": {
    "editor": "Boardmaker 7 Éditor",
    "activations": "Activations",
    "languages": "Langues**",
    "licensing": "Licences",
    "pcsSymbols": "PCS Symbols",
    "templates": "Modèles",
    "studentCenter": "Boardmaker 7 Student Center",
    "playActivitiesInstructor": "Activités ludiques en tant qu'instructeur",
    "playActivitiesStudent": "Activités ludiques en tant qu'apprenant",
    "myBoardmaker": "myBoardmaker",
    "instructorManagement": "Gestion de l’instructeur",
    "studentManagement": "Gestion de l’apprenant",
    "assignStudentActivities": "Attribuer des activités aux apprenants",
    "cloudStorage": "Stockage sur le cloud",
    "createAndJoin": "Créer et rejoindre des groupes",
    "accessCommunity": "Accès à 120 000 activités Community",
    "shareActivity": "Partager des activités dans Community",
    "curriculum": "Programme et contenu",
    "activitiesToGo": "Activities to Go Boardmaker",
    "instructionalSolutions": "Instructional Solutions",
    "premiumActivities": "Activités haut de gamme",
    "coreFirstLearning": "Core First Learning"
  },
  "rowValues": {
    "byDevice": "2 dispositifs",
    "unlimited": "Illimité",
    "byKey": "Clé de licence",
    "symbols": "Plus de 80 000",
    "templates": "Plus de 600",
    "languages": "12",
    "login": "Connexion",
    "yes": "Oui",
    "yesNote": "Oui***",
    "no": "Non"
  }
}